import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import ByInterface from "./ByInterface/ByInterface";
import NeedAttention from "./NeedAttention/NeedAttention";

const TAB_KEYS = ["by_interface", "need_attention"];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const FamiliesTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = Math.max(0, TAB_KEYS.indexOf(searchParams.get("familiesTab") ?? "by_interface"));

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    const next = new URLSearchParams(searchParams);
    if (newValue === 0) {
      next.delete("familiesTab");
    } else {
      next.set("familiesTab", TAB_KEYS[newValue]);
    }
    setSearchParams(next, { replace: true });
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{
              "& .MuiTab-root": {
                color: "#00000099",

                "&.Mui-selected": {
                  color: "#9C27B0",
                },
              },

              /* Active line color */
              "& .MuiTabs-indicator": {
                backgroundColor: "#9C27B0",
                height: "3px", // optional
                borderRadius: "10px", // optional
              },

              "& .MuiTabs-flexContainer": {
                justifyContent: "flex-start",
              },

              "& .MuiTab-root:first-of-type": {
                paddingLeft: 2,
              },
            }}
          >
            <Tab label="By Interface" {...a11yProps(0)} />
            <Tab label="Need Attention" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <ByInterface />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <NeedAttention />
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default FamiliesTabs;
